<template>
  <div
    :style="{ backgroundColor: panelBackgroundColor }"
    class="max-w-xl w-full sm:rounded-lg sm:shadow-lg px-6 py-4
    flex flex-col items-center justify-center mt-4"
  >
    <p
      class="text-lg mb-2 font-bold"
      style="color: #000000;"
    >
      {{ registrationRequestPanelMessages.title }}
    </p>
    <Button
      :style="{ backgroundColor: registrationRequestPanelUtils.btnBackground }"
      class="w-80"
      type="primary"
      @onClick="switchToRegistration"
    >
      {{ registrationRequestPanelMessages.btnText }}
    </Button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Button from '@/components/atoms/Button.vue';
import { mapGetters } from 'vuex';
import { RegistrationRequestPanelUtils } from '@/model/clientConfig';

export default defineComponent({
  name: 'RegistrationPanel',
  components: {
    Button
  },
  emits: ['registration-request'],
  methods: {
    switchToRegistration () {
      this.$router.push({
        path: '/registration',
        query: {
          ...this.$route.query
        }
      });
    }
  },
  computed: {
    ...mapGetters([
      'registrationRequestPanelMessages',
      'registrationRequestPanelUtils'
    ]),
    panelBackgroundColor () {
      const utils = (this as unknown as {
        registrationRequestPanelUtils?: RegistrationRequestPanelUtils
      }).registrationRequestPanelUtils;

      return utils?.registrationBackground || '#E5EFF699';
    }
  }
});
</script>
